import { useHttp } from '@/api'
import { httpApi } from '@/api/api'
import { ShowErrorList } from '@/components/Dialog'
import { t } from '@/locales'
import { Modal } from '@tellus/component'
export default {
  // 検索画面の初期化
  InitSearch() {
    return new Promise((resolve, reject) => {
      useHttp()
        .request(httpApi.RoleSearch, {
          errCallback: err => {
            reject(err)
          }
        })
        .then(res => {
          resolve(res)
        })
    })
  },
  // 新規画面/変更画面の初期化
  Init(data, isEntry) {
    return new Promise(resolve => {
      useHttp()
        .request(isEntry ? httpApi.RoleInitEntry : httpApi.RoleInitChange, data)
        .then(res => {
          resolve(res)
        })
    })
  },
  // 新規
  Entry(data, callback) {
    Modal.showInfo('', t('message.confirm.entry'), {
      $type: 'prompt',
      confirmButtonText: t('resource.button.sure'),
      cancelButtonText: t('resource.button.cancel'),
      showCancelButton: true
    })
      .then(() => {
        useHttp()
          .request(httpApi.RoleEntry, data)
          .then(() => {
            // ロールストレージの再構築
            useHttp()
              .request(httpApi.RoleStoreBuild)
              .then(() => {
                Modal.showSuccess('', t('message.success.process', [t('resource.button.entry')])).then(() => {
                  callback()
                })
              })
          })
          .catch(err => {
            ShowErrorList(err.data.Messages)
          })
      })
      .catch(() => {})
  },
  // 変更
  Change(data, callback) {
    Modal.showInfo('', t('message.confirm.operation'), {
      $type: 'prompt',
      confirmButtonText: t('resource.button.sure'),
      cancelButtonText: t('resource.button.cancel'),
      showCancelButton: true
    })
      .then(() => {
        useHttp()
          .request(httpApi.RoleChange, data)
          .then(() => {
            // ロールストレージの再構築
            useHttp()
              .request(httpApi.RoleStoreBuild)
              .then(() => {
                Modal.showSuccess('', t('message.success.process')).then(() => {
                  callback()
                })
              })
          })
          .catch(err => {
            ShowErrorList(err.data.Messages)
          })
      })
      .catch(() => {})
  }
}
